import axios from 'axios'
import configuare from './config'
import i18n from '@/i18n'
import { Message } from 'hui'
import { REQUEST_SUCCESS, REFRESH_BY_HEADER } from '@/constant'

const http = axios.create({
  timeout: 20000,
  withCredentials: true,
  headers: { 'X-Requested-With': 'XMLHttpRequest' }
})

http.interceptors.response.use(
  function (response) {
    // 请求多语言的json/js文件
    if (/.*\.(json|js)$/.test(response.config.url)) {
      return response
    }
    // 根据响应数据判断是否登录过期
    if (response.data.errorCode === REFRESH_BY_HEADER) {
      let refreshUrl = response.headers['refresh-url'].split('?')[0]
      refreshUrl =
        refreshUrl +
        '?service=' +
        location.protocol +
        '//' +
        location.host +
        location.pathname +
        encodeURIComponent(location.search)
      location.href = refreshUrl
      return
    }

    // 对错误进行统一处理
    if (response.data.code !== REQUEST_SUCCESS) {
      if (!response.config.noMsg && response.data.msg) {
        Message.error(i18n.t(response.data.msg))
      }
      return Promise.reject(response)
    } else if (
      response.data.code === REQUEST_SUCCESS &&
      response.config.successNotify
    ) {
      // 弹出成功提示
      Message.success(i18n.t(response.data.msg) || 'success !')
    }
    return Promise.resolve({
      code: response.data.code,
      msg: response.data.msg,
      data: response.data.data
    })
  },
  function (error) {
    Message.error(i18n.t('common.errorServe'))
    //   if (error.message.indexOf('timeout') > -1) {
    //   // 多语言需要自己在项目中配置
    //   // eslint-disable-next-line
    //   Message.error(i18n.t('common.http_over_time'))
    // } else {
    // }
    // 对响应错误做点什么
    return Promise.reject(error)
  }
)

http.interceptors.request.use(
  config => {
    // 对于非JSON的请求，默认添加一个baseUrl
    if (config.url.indexOf('json') < 0 && config.url.indexOf('.js') < 0) {
      config.url = `${configuare.baseUrl}${config.url}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

export default {
  post (url, params = {}, headers = {}) {
    return http({
      method: 'post',
      url,
      data: params,
      headers
    })
  },
  get (url, params = {}, headers = {}) {
    if (!params['t']) params['t'] = new Date().getTime()
    return http({
      method: 'get',
      url,
      params,
      headers
    })
  }
}
